import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNavBar from '../../../../../components/common/hr/topnav.component';
import HRLogin from '../../../../../setup/auth/hr.component';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DataTableCustomStyles } from '../../../../../components/helper/dataTable.config';
import { CustomerCategory, Customer, CustomerSegment, GTM } from '../../../../../models'
import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import { Auth } from 'aws-amplify';
import * as alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import EditButton from '../../../../../components/common/buttons/EditButton';
import DeleteButton from '../../../../../components/common/buttons/DeleteButton';
import { ValidateHRRole } from '../../../../../components/helper/validateRole';
import { ConvertResponseForId, ObjectToArray } from '../../../../../components/helper/commonfunctions'
import ImportDimension from '../../../../../components/common/import/dimensionsimport.component';
import { ProgressSpinner } from 'primereact/progressspinner';
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import * as mutations from '../../../../../graphql/mutations';
import * as queries from '../../../../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';

export default function CustomerCategoryList() {

    let navigateTo = useNavigate();
    const [checkCustomerList, setCheckCustomerList] = useState([]);
    const [isPageLoaded, setPageLoaded] = useState(false);

    // Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    // State for customer category list
    const [customerCategoryList, setCustomerCategoryList] = useState("");
    const [customerCategoryFilterList, setCustomerCategoryFilterList] = useState("");
    const [isShowImportPopup, setIsShowImportPopup] = useState(false);


    const handleEditClick = (e, id) => {
        e.preventDefault();
        navigateTo('/hr/setting/dimensions/customerCategory/createCustomerCategory/' + id);
    };

    const handleDeleteClick = async (e, id) => {
        e.preventDefault();
        // const objDeleteCustomerCategory = await DataStore.query(CustomerCategory, id);
        const objDeleteCustomerCategory = await graphQLFindRecordById('getCustomerCategory', id);

        alertify.confirm('Confirmation', 'Do you want to delete this record?', async function () {
            //Delete customer category
            // DataStore.delete(objDeleteCustomerCategory);
            await API.graphql({
                query: mutations.deleteCustomerCategory,
                variables: {
                    input: {
                        id: objDeleteCustomerCategory.id,
                        _version: objDeleteCustomerCategory._version,
                    }
                }
            });
            BindList();
            toast.success("Deleted");
        }
            , function () { });
    };

    // Column Name
    const DataTableColumns = [
        {
            name: 'Customer Group',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Ref Code',
            selector: row => row.REF_CODE,
            sortable: true,
        },
        {
            name: 'Customer Segment',
            selector: row => row.customerSegment,
            sortable: true,
        },
        {
            name: 'GTM',
            selector: row => row.GTM,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row) => (
                <>
                    <div className="flex gap-8">
                        <Link onClick={(e) => handleEditClick(e, row.id)} ><EditButton /></Link>
                        {
                            ConvertResponseForId(checkCustomerList, row.id) === row.id ?
                                <Link className="disabledCursor opacity-50"  ><DeleteButton /></Link> :
                                <Link onClick={(e) => handleDeleteClick(e, row.id)} ><DeleteButton /></Link>
                        }
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            center: true
        }
    ];

    //Search Customer Category
    const searchCustomerCategory = (searchedText) => {
        if (searchedText.length > 1) {
            let data = [...customerCategoryFilterList]
            let filteredData = data.filter(e =>
                e.name.toLowerCase().includes(searchedText.toLowerCase()) ||
                e.GTM.toLowerCase().includes(searchedText.toLowerCase()) ||
                e.REF_CODE.toLowerCase().includes(searchedText.toLowerCase()) ||
                e.customerSegment.toLowerCase().includes(searchedText.toLowerCase())
            )
            setCustomerCategoryList(filteredData)
        } else {
            let data = [...customerCategoryFilterList]
            setCustomerCategoryList(data)
        }
    }
    //onClick Close popup
    async function onClickCloseImportPopup() {
        setIsShowImportPopup(false);
        BindList();
    }

    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    async function BindList() {
        // var customerCategoryResponses = await DataStore.query(CustomerCategory, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        var customerCategoryResponses = await graphQLGetAllData('listCustomerCategories');
        customerCategoryResponses = customerCategoryResponses.sort((a, b) => a.name.localeCompare(b.name));

        var newResponse = [];
        if (customerCategoryResponses.length > 0) {

            Object.keys(customerCategoryResponses).map(async (currentItem, i) => {
                let loopItem = customerCategoryResponses[currentItem];
                let data = ObjectToArray(loopItem);

                var customerSegment = "-";
                if (data["customer_segment_id"]) {
                    // var customerSegmentResponse = await DataStore.query(CustomerSegment, data["customer_segment_id"]);

                    var customerSegmentResponse = await graphQLFindRecordById('getCustomerSegment', data["customer_segment_id"]);

                    if (customerSegmentResponse) {
                        customerSegment = customerSegmentResponse.name + " (" + customerSegmentResponse.REF_CODE + ")"
                    } else { customerSegment = "-"; }
                } else { customerSegment = "-"; }

                var gtm = "-";
                if (data["gtm_i"] !== null && data["gtm_i"] !== "") {
                    // var gmtResponse = await DataStore.query(GTM, data["gtm_i"]);
                    var gmtResponse = await graphQLFindRecordById('getGTM', data["gtm_i"]);


                    if (gmtResponse.name) {
                        gtm = gmtResponse.name + " (" + gmtResponse.REF_CODE + ")"
                    } else { gtm = "-"; }
                } else { gtm = "-"; }

                data["customerSegment"] = customerSegment
                data["GTM"] = String(gtm)

                newResponse.push(data);

                //On Last Record assign to state
                if (i === customerCategoryResponses.length - 1) {
                    newResponse = newResponse.sort((a, b) => a.name.localeCompare(b.name));
                    setTimeout(()=>{
                        setCustomerCategoryList(newResponse)
                        setCustomerCategoryFilterList(newResponse)
                        setPageLoaded(true)
                    },200)
               
                }

            })
        }
        else {
            setCustomerCategoryList([])
            setCustomerCategoryFilterList([])
            setPageLoaded(true)
        }

        //customer data for delete enable
        let customerLength = []
        // var customerResponses = await DataStore.query(Customer);
        var customerResponses = await graphQLGetAllData('listCustomers');

        customerResponses.map((response) => {
            let data = { id: response.customer_category_id }
            customerLength.push(data)
        })
        setCheckCustomerList(customerLength)
    }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);

    return (
        isAuthenticated ? (
            <div>
                <div className="pt-16">
                    <TopNavBar />
                    <LeftSideBar />
                    <div className="dashboard-main-wrapper pl-20 pr-4 mt-3">
                        <div className="flex flex-1 flex-wrap p-5 pb-4 px-0 top-action-wrapper">
                            <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                <div className="md:flex block md:col-span-2 mb-4">
                                </div>
                                <div className="md:flex block mb-4">
                                    <h2 className="page-title">Customer Group</h2>
                                </div>
                            </div>

                            <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">
                                <div className="relative">
                                    <input onChange={(e) => searchCustomerCategory(e.target.value)} type="text" id="required-search" className="rounded-md border border-[#D0D5DD] focus:border-transparent w-full py-2.5 pl-3 bg-white text-gray-700 placeholder-gray-500 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-[#403E3C] dark:text-[#FFFFFF] dark:border-[#403E3C]" placeholder="Search..." />
                                </div>
                                <div className="md:flex block mb-4 gap-4">
                                    <Link to="/hr/settings" className="flex py-2 px-5 bg-[#FFF] hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-black transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] dark:border-[#4A5056] dark:bg-[#4A5056] dark:text-white">
                                        Back
                                    </Link>
                                    <Link onClick={() => {
                                        setIsShowImportPopup(true);
                                    }} className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-black">
                                        Import
                                    </Link>
                                    <Link to="/hr/setting/dimensions/customerCategory/createCustomerCategory" className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-black">
                                        Create
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className={"block w-full pt-5"}>
                                {
                                    isPageLoaded &&
                                    <DataTable
                                        columns={DataTableColumns}
                                        data={customerCategoryList}
                                        customStyles={DataTableCustomStyles}
                                        pagination
                                        highlightOnHover
                                        paginationPerPage={10}
                                    />
                                }
                                {
                                    !isPageLoaded &&
                                    <div className='text-center py-10' >
                                        <ProgressSpinner style={{ width: '80px', height: '80px', zIndex: '9999' }} strokeWidth="3" fill="var(--surface-ground)" animationDuration=".8s" />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        isShowImportPopup &&
                        <ImportDimension
                            closePopup={onClickCloseImportPopup}
                            type={"CustomerCategory"}
                        />
                    }
                </div>
            </div>

        ) : (
            <HRLogin sessionExpired={1} />
        )
    )
}
